<template>
  <b-form class="text-uppercase p-4" id="preview-form">
    <div class="form-row">
      <div v-for="(item, key) in sortInputs()" :key="key" class="col-md-6">
        <!-- TYPE TEXT / COMMON -->
        <div class="form-group col-md-12 text" v-if="checktype(item.type) == 'text'">
          <label for="item.id">{{item.label}}</label>
          <input
            :type="item.type"
            :id="item.id"
            v-model="objItem[item.id]"
            class="form-control"
            :readonly="item.read_only"
            :required="item.column_required"
          />
        </div>

        <!-- TYPE SELECT -->
        <div class="form-group col-md-12 select" v-if="checktype(item.type) == 'select'">
          <label for="item.id">{{item.label}}</label>
          <select
            :id="item.id"
            v-model="objItem[item.id]"
            class="form-control"
            :readonly="item.read_only"
            :required="item.column_required"
          >
            <option
              v-for="(opt, opt_key) in item.options"
              :value="opt.value"
              :key="key+'-'+opt_key"
            >{{opt.text}}</option>
          </select>
        </div>

        <!-- TYPE CHECKBOX -->
        <div class="form-group col-md-12 checkbox" v-if="checktype(item.type) == 'checkbox'">
          <label>{{item.label}}</label>
          <div v-for="(check, check_key) in item.options" :key="key+'-'+check_key">
            <input
              :type="item.type"
              :id="'id'+check_key"
              :value="check.value"
              v-model="objItem[item.id]"
              :readonly="item.read_only"
              :required="item.column_required"
            />
            <label :for="'id'+check_key">{{check.text}}</label>
          </div>
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
export default {
  name: "BpmTaskColumnForm",
  props: {
    objItems: Array
  },
  components: {},
  computed: {},
  data: function() {
    return {
      // result
      objItem: {},
      // input example
      inputs: []
    };
  },
  methods: {
    // Adapt code to form gen
    generateInputsArray() {
      let obj = [];
      this.objItems.forEach(element => {
        this.inputs = [];
        let label = element.bpm_task_column_data.task_column_label;
        let name = element.bpm_task_column_data.task_column_name;
        let type = "";
        let readOnly = false;
        let columnRequired = false;
        let column_order = element.bpm_task_column_data.column_order;

        if (element.bpm_task_column_data.read_only == "Y") readOnly = true;
        if (element.bpm_task_column_data.column_required == "Y")
          columnRequired = true;

        switch (element.bpm_task_column_data.column_type.toLowerCase()) {
          case "varchar":
            type = "text";
            break;
          case "integer":
            type = "number";
            break;
          case "timestamp":
            type = "date";
            break;
          default:
            // none;
            break;
        }

        obj.push({
          type: type,
          id: name,
          label: label,
          read_only: readOnly,
          column_required: columnRequired,
          column_order: column_order
        });
      });
      this.inputs = obj;
    },

    // Defines de type of input to HTML mount
    checktype(type) {
      if (
        [
          "text",
          "password",
          "number",
          "email",
          "url",
          "date",
          "datetime-local",
          "hidden",
          "time"
        ].includes(type)
      )
        return "text";
      if (["select"].includes(type)) return "select";
      if (["checkbox"].includes(type)) return "checkbox";
      return null;
    },
    sortInputs() {
      if (this.inputs) {
        return this.inputs.slice().sort(function(a, b) {
          return a.column_order > b.column_order ? 1 : -1;
        });
      } else {
        return null;
      }
    }
  },
  mounted() {
    this.generateInputsArray();
    // To mount checkbox its necessary to set the var to array
    this.inputs.forEach(element => {
      if (["checkbox"].includes(element.type)) {
        this.$set(this.objItem, element.id, []);
      }
    });
  },
  watch: {
    objItems() {
      this.generateInputsArray();
    }
  }
};
</script>